export default __webpack_public_path__ + "static/media/Claxton-Light.4479b133.otf";